// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getShipTos } from "@insite/client-framework/Services/CustomersService";
import { chain, FindDefaultShipTo } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {},
    {
        defaultBillTo?: BillToModel;
        defaultShipTo?: ShipToModel;
        showSelectDefaultCustomer: boolean;
        useDefaultCustomer: boolean;
        hasMultipleBillTos: boolean;
    }
>;

export const XngFindDefaultShipTo: HandlerType = async props => {
    if (!props.defaultBillTo) {
        return;
    }

    const shipToCollection = await getShipTos({
        // xng-change RC-2359: adding expand
        expand: ["default"] as any,
        billToId: props.defaultBillTo.id,
        exclude: ["oneTime", "showAll"],
    });
    const shipTos = shipToCollection.shipTos!;
    if (shipTos.length === 1 && shipTos[0].id !== "Show All") {
        props.defaultShipTo = shipTos[0];
    } else {
        const defaultShipTos = shipTos.filter(o => o.isDefault);
        if (defaultShipTos.length === 1) {
            props.defaultShipTo = defaultShipTos[0];
        }
    }
};

replaceInChain(chain, FindDefaultShipTo, XngFindDefaultShipTo);
